/**
 * Where to send someone after a subscription checkout.
 *
 * An upgrade usually starts at a wall (certificate admin, posting a job, the
 * seller panel). Stripe returns to /subscription/success, which used to offer
 * only "Go to Dashboard", so people had to find their way back to what they
 * were doing. The upgrade modal remembers the page; the success page returns
 * them to it. sessionStorage survives the same-tab round trip to Stripe.
 */

const KEY = "drx:upgradeReturnTo";

export function rememberUpgradeReturn(path: string): void {
  // Only in-app paths, and never the subscription pages themselves.
  if (!path.startsWith("/") || path.startsWith("//") || path.startsWith("/subscription")) return;
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    /* storage blocked: the success page falls back to the dashboard */
  }
}

/** The remembered page, cleared once read. */
export function takeUpgradeReturn(): string | null {
  try {
    const path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return path && path.startsWith("/") && !path.startsWith("//") ? path : null;
  } catch {
    return null;
  }
}
